import React from 'react';
import { get } from 'lodash-es';
/* Utils */
import { postFinancingExistingPrequalify } from 'site-modules/financing/utils/post-financing';
/* Constants */
import { LOOK_UP_STEP } from 'site-modules/shared/constants/financing/steps';
/* Components */
import { pageDefinition } from 'site-modules/shared/pages/page';
import { PersonalScreen } from 'client/site-modules/financing/components/personal-screen/personal-screen';
import { FinancingDecorator } from 'client/site-modules/financing/decorators/financing-decorator';
import { PreQualificationFound } from 'site-modules/financing/components/personal-screen/components/pre-qualification-found-step/pre-qualification-found-step';
import { postForm } from 'site-modules/shared/pages/post-form';
import { PrequalifyCheck } from 'site-modules/financing/pages/steps/prequalify-check';
import { FinancingDecoratorFactoryPreload } from './financing-model-preloader';
import { getSeoObject } from './seo';

export const Personal = pageDefinition({
  name: 'financing_personal',
  category: 'financing',
  decorator: FinancingDecorator,
  preload: FinancingDecoratorFactoryPreload,
  seo: getSeoObject,
  component: options => {
    const activeStep = get(options, 'currentStep.originalPath', '');

    if (activeStep === LOOK_UP_STEP) {
      return (
        <PreQualificationFound
          vin={options.vin}
          enableNextBtn={options.enableNextBtn}
          isMatchingVIN={options.isMatchingVIN}
          showErrorPage={options.showErrorPage}
          isLoadingFeedbackScreen={options.isLoadingFeedbackScreen}
          onSubmit={options.onSubmit}
          setQualifiedStatus={options.setQualifiedStatus}
          goToPrevScreen={options.goToPrevScreen}
          enabledNextBtn={options.enabledNextBtn}
          vehicle={options.vehicle}
          sendConsumerEmail={options.sendConsumerEmail}
          redirectPage={options.redirectPage}
          debugFinancingAPI={options.debugFinancingAPI}
          isLoading={options.isLoading}
          setFormData={options.setFormData}
          showModal={false} // showModal=false to prevent open Insider Authenticated Modal
          isPreVinFlow={options.isPreVinFlow}
          isAllowBypassApiGateway={options.isAllowBypassApiGateway}
          calculatorSelections={options.calculatorSelections}
        />
      );
    }

    return (
      <PersonalScreen
        enableNextBtn={options.enableNextBtn}
        isJoint={options.isJoint}
        validationInfo={options.validationInfo}
        isBackState={options.isBackState}
        prefillFromStorage={options.prefillFromStorage} // TODO: Remove when shop-4713-prequal2 test is cleaned up
        isProdEnv={options.isProdEnv}
        isMatchingVIN={options.isMatchingVIN}
        setFormData={options.setFormData}
        isPreVinFlow={options.isPreVinFlow}
      />
    );
  },

  options: {
    disableScrollToTop: true,
  },
});

export default postForm(Personal, {
  confirmationPage: PrequalifyCheck,
  onSubmit: postFinancingExistingPrequalify,
});
